import { Link, useParams } from 'react-router-dom';
import { Breadcrumbs } from '@/components/site/Breadcrumbs';
import { FaqList } from '@/components/site/FaqList';
import { Prose } from '@/components/site/Prose';
import { SiteMeta } from '@/components/site/SiteMeta';
import { findGuide, guides } from '@/content/guides';
import { NotFoundPage } from '@/pages/site/seo/NotFoundPage';

function formatDate(iso: string): string {
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano}`;
}

export function GuidePage() {
  const { slug = '' } = useParams();
  const guide = findGuide(slug);
  if (!guide) return <NotFoundPage />;
  const outros = guides.filter((g) => g.slug !== guide.slug);

  return (
    <>
      <SiteMeta title={`${guide.title} | Operax`} description={guide.description} path={`/guias/${guide.slug}`} />

      <section className="page-hero">
        <div className="hero-grid-bg" />
        <div className="shell page-hero-in rev">
          <Breadcrumbs
            items={[
              { name: 'Início', path: '/' },
              { name: 'Guias', path: '/guias' },
              { name: guide.title },
            ]}
          />
          <div className="eyebrow">Guia</div>
          <h1>{guide.title}</h1>
          <p className="seo-meta">
            Publicado em <time dateTime={guide.published}>{formatDate(guide.published)}</time> · Atualizado em{' '}
            <time dateTime={guide.updated}>{formatDate(guide.updated)}</time> · Por Operax
          </p>
        </div>
      </section>

      <section className="pad">
        <article className="shell seo-article">
          <p className="seo-summary">
            <strong>Resposta curta.</strong> {guide.summary}
          </p>
          <Prose markdown={guide.markdown} />

          {guide.faq.length > 0 && (
            <>
              <h2>Perguntas frequentes</h2>
              <FaqList entries={guide.faq} />
            </>
          )}

          <aside className="seo-aside">
            <h2>Fontes</h2>
            <ul>
              {guide.sources.map((source) => (
                <li key={source.url}>
                  <a href={source.url} target="_blank" rel="noopener">
                    {source.label}
                  </a>
                </li>
              ))}
            </ul>
          </aside>
        </article>
      </section>

      <section className="pad seo-soft">
        <div className="shell">
          <div className="sec-head rev">
            <div className="eyebrow">Continue lendo</div>
          </div>
          <div className="seo-guide-list">
            {outros.map((g) => (
              <Link key={g.slug} className="seo-guide-card rev" to={`/guias/${g.slug}`}>
                <h2>{g.title}</h2>
                <p>{g.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
